import React from "react";
import styles from "./button.scss";

const Button = ({
  id,
  text,
  icon,
  onClick,
  disabled = false,
  variant = "pale",
  className,
  type = "button",
  title,
  children,
  active = false,
}) => {
  return (
    <button
      id={id}
      type={type}
      disabled={disabled}
      className={`${className ?? ""} ${
        variant === "contained" ? styles.contained : styles.pale
      } ${active ? styles.active : ""}`}
      onClick={(e) => !disabled && onClick(e)}
      title={title}
    >
      {icon && (
        typeof icon === 'string' ? 
          <img src={icon} alt="" /> : 
          <span className={styles.iconWrapper}>{icon}</span>
      )}
      {children}
      {text}
    </button>
  );
};

export default Button;
